import "@/styles/styles.css";

import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";

import { router } from "@/router";
import { queryClient } from "@/queryClient";
import { initClarity } from "@/utils/clarity";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element #root not found");
}

// Microsoft Clarity — production-only. No-op in staging + dev builds so
// session-replay never captures operators running against the sandbox or
// a local backend. See src/utils/clarity.ts for the gating logic.
initClarity();

createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </React.StrictMode>,
);
